import {FC} from "react";
import {StatusUiProps} from "./StatusUiProps";
import {StatusIndicator} from "./StatusIndicator";
import {IconComponent} from "./IconComponent";

/**
 * A simple UI that is rendered while waiting for scripts to load.
 *
 * @param scriptId
 * @param className
 * @constructor
 */
export const DefaultLoadingIndicator: FC<StatusUiProps> = ({
  scriptId,
  className
}) => {
  return (
    <StatusIndicator
      scriptId={scriptId}
      status={"loading"}
      className={className}>
      <IconComponent color={"rgba(5, 133, 200, 0.1)"} />
    </StatusIndicator>
  );
};
